const Container = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="container">
      <path
        id="Icon"
        d="M27.3333 9.88509L16 16.1814M16 16.1814L4.66662 9.88509M16 16.1814L16 28.8481M28 21.5928V10.77C28 10.3132 28 10.0847 27.9327 9.881C27.8731 9.70077 27.7758 9.53533 27.6472 9.39574C27.5018 9.23796 27.3021 9.12702 26.9027 8.90515L17.036 3.42367C16.6579 3.21359 16.4688 3.10855 16.2686 3.06737C16.0914 3.03093 15.9086 3.03093 15.7314 3.06737C15.5312 3.10855 15.3421 3.21359 14.964 3.42367L5.09729 8.90516C4.69793 9.12702 4.49825 9.23796 4.35284 9.39574C4.22421 9.53533 4.12686 9.70077 4.06731 9.88101C4 10.0847 4 10.3132 4 10.77V21.5928C4 22.0497 4 22.2781 4.06731 22.4819C4.12686 22.6621 4.22421 22.8275 4.35284 22.9671C4.49825 23.1249 4.69793 23.2358 5.0973 23.4577L14.964 28.9392C15.3421 29.1493 15.5312 29.2543 15.7314 29.2955C15.9086 29.3319 16.0914 29.3319 16.2686 29.2955C16.4688 29.2543 16.6579 29.1493 17.036 28.9392L26.9027 23.4577C27.3021 23.2358 27.5018 23.1249 27.6472 22.9671C27.7758 22.8275 27.8731 22.6621 27.9327 22.4819C28 22.2781 28 22.0497 28 21.5928Z"
        stroke="#4C1D95"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Container;
